import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';


import { HeaderLoggedUserView } from './HeaderLoggedUserView';
import { HeaderAuthView } from './HeaderAuthView';
import { withAppContext, AppContextProps } from '../../../context/AppContext';


export class HeaderC extends React.PureComponent<RouteComponentProps<{}> & AppContextProps> {
  renderHeaderViews = (loggedUser: any) => {
    if (loggedUser === undefined) {
      return null;
    } else if (loggedUser === null) {
      return <HeaderAuthView />;
    } else {
      return <HeaderLoggedUserView loggedUser={loggedUser} />;
    }
  }
  render() {
    return this.renderHeaderViews(this.props.context.loggedUser);
  }
}

export const HeaderConnector = withAppContext(HeaderC);


// WEBPACK FOOTER //
// ./src/modules/layout/header/HeaderConnector.tsx